import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {NzMessageService} from "ng-zorro-antd/message";
import {lastValueFrom} from "rxjs";
import {EQConnectorKeyDto, PerFormaAPIService} from "src/app/services/pfapi.service";

@Component({
    selector: "app-eq-connector-key",
    templateUrl: "./eq-connector-key.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EQConnectorKeyComponent implements OnInit {
    constructor(
        private readonly api: PerFormaAPIService,
        private message: NzMessageService
    ) {}

    loading = true;
    model: EQConnectorKeyDto = {};
    uniqueKeyInput = "";

    async ngOnInit() {
        await this.getData();
    }

    getData = async () => {
        this.loading = true;
        try {
            this.model = await lastValueFrom(this.api.getApiConfigureEqConnectorKey());
            this.uniqueKeyInput = this.model.CurrentUniqueKey ?? "";
        } catch (e) {
            this.message.error("Failed to load connector key info");
            console.log(e);
        } finally {
            this.loading = false;
        }
    };

    setUniqueKey = async () => {
        this.loading = true;
        try {
            await lastValueFrom(this.api.putApiConfigureEqConnectorKeyUnique({keyValue: this.uniqueKeyInput}));
            this.message.success("Unique key saved");
            await this.getData();
        } catch (e) {
            this.message.error("Failed to save unique key");
            console.log(e);
            this.loading = false;
        }
    };

    clearUniqueKey = async () => {
        this.loading = true;
        try {
            await lastValueFrom(this.api.deleteApiConfigureEqConnectorKeyUnique());
            this.message.success("Unique key cleared");
            await this.getData();
        } catch (e) {
            this.message.error("Failed to clear unique key");
            console.log(e);
            this.loading = false;
        }
    };

    regenerateLicense = async () => {
        this.loading = true;
        try {
            await lastValueFrom(this.api.postApiConfigureEqConnectorKeyRegenerate());
            this.message.success("License key regenerated");
            await this.getData();
        } catch (e) {
            this.message.error("Failed to regenerate license key");
            console.log(e);
            this.loading = false;
        }
    };
}
